<form class="h-100" [formGroup]="from" autocomplete="off">
  <div class="d-flex flex-column h-100">
    <div class="gx-3 row">
      <div class="col-sm-6 mb-3">
        <input-field
          [label]="'Code'"
          [type]="'text'"
          [placeholder]="'Enter Code'"
          formControlName="code"
          [requiredLabel]="true"
          [errormessage]="'Code is required'"
        >
        </input-field>
      </div>

      <div class="col-sm-6 mb-3">
        <input-field
          [label]="'Abbreviation'"
          [type]="'text'"
          [placeholder]="'Enter Abbreviation'"
          formControlName="abbreviation"
          [errormessage]="'Abbreviation must be less than 10 characters'"
        >
        </input-field>
      </div>

      <div class="col-sm-12 mb-3">
        <input-field
          [label]="'Description'"
          [type]="'text'"
          [placeholder]="'Enter Description'"
          formControlName="description"
          [requiredLabel]="true"
          [errormessage]="'Description is required'"
        >
        </input-field>
      </div>
    </div>
  </div>
</form>
